/**
 * Synchronous escape hatch for callers that perform a full-page redirect
 * immediately after firing a real offramp (e.g. offRampToAlfiePrePricing).
 * React's render cycle cannot commit before pagehide fires in that case, so
 * we cannot rely on enabled/hasOfframped flipping the closure in time.
 * Reset is unnecessary — the module re-initialises on every full page load.
 */
let suppressed = false

export function suppressAbandonmentOfframp(): void {
  suppressed = true
}

export function isAbandonmentOfframpSuppressed(): boolean {
  return suppressed
}

let assignmentSuppressed = false

export function suppressAbandonmentAssignment(): void {
  assignmentSuppressed = true
}

export function isAbandonmentAssignmentSuppressed(): boolean {
  return assignmentSuppressed
}
